import request from "@/app/api/request";
import {
  ChatModelRequest,
  ChatModelResponse,
  ChatWithDanaModel,
  DeleteChatRequest, FilesUploadResponse,
  SendMessageRequest, SendMessageResponse
} from "@/app/api/chatWithDana/models";

export class ChatWithDanaRequest {

  static async getChatsWithDana() {
    try {
      return await request.get<ChatWithDanaModel[]>('/chatWithDana/getChatsWithDanaForCurrentUser', {});
    } catch (error: any) {
      throw error;
    }
  }

  static async getChat(query: ChatModelRequest) {
    try {
      return await request.get<ChatModelResponse[]>('/chatWithDana/getChatWithDanaByChatId', {query});
    } catch (error: any) {
      throw error;
    }
  }

  static async deleteChat(query: DeleteChatRequest) {
    try {
      return await request.delete<string>('/chatWithDana/deleteChatWithDanaById', {query});
    } catch (error: any) {
      throw error;
    }
  }

  static async createChat() {
    try {
      return await request.post<ChatWithDanaModel>('/chatWithDana/createNewChatWithDana', {});
    } catch (error: any) {
      throw error;
    }
  }

  static async sendMessage(query: SendMessageRequest) {
    try {
      return await request.post<SendMessageResponse>('/chatWithDana/askDanaInChat', {query: query});
    } catch (error: any) {
      throw error;
    }
  }

  static async sendFiles(formData: FormData): Promise<string[]> {
    try {
      return await request.post<string[]>('chatWithDana/uploadFilesToS3', {
        data: formData,
        config: {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      });
    } catch (error: any) {
      throw error;
    }
  }
}


